import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../components/dashboard/Container'
import Configuracion from '../components/configuracion/Container'
import Partes from '../components/partes/Container'
import Clientes from '../components/clientes/Container'
import ClienteShow from '../views/clientes/ClienteShow'
import Usuarios from '../components/usuarios/Container'
import Arditimer from '../components/arditimer/Container'
import Asientos from '../components/saldos/Container'
// import ListadoAcciones from '../components/listadoAcciones/Container'
import ListadoAcciones from '../components/listadoAcciones/Container'
import PacksHoras from '../components/packsHoras/Container'
import AccionesMasivas from '../components/accionesMasivas/accionesMasivas/Container'
import MisGrupos from '../components/accionesMasivas/misGrupos/Container'
import MisComentarios from '../components/accionesMasivas/misComentarios/Container'
import Ardiagenda from '../components/ardiagenda/Container'
import MiPerfil from '../components/miPerfil/Container'
import Login from '../components/login/LoginForm'
import Calendario from '../components/calendario/Container'
import Informes from '../views/informes/InformesIndex'
import RegistroComponentes from '../components/registroComponentes/Container'
import store from '../store'
import { redirect } from '../utils/redirect'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    meta: {
      componenteId: null,
      menuText: 'Inicio',
      title: 'Inicio',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-chart-arc',
      parent: null,
    },
    component: Dashboard,
  },
  {
    path: '/configuracion',
    name: 'configuracion',
    meta: {
      componenteId: null,
      menuText: 'Configuración',
      title: 'Configuración',
      requiresAuth: true,
      displayIn: 'userMenu',
      icon: 'mdi-cog-outline',
      parent: null,
    },
    component: Configuracion,
  },
  {
    path: '/partes',
    name: 'partes',
    meta: {
      componenteId: 1,
      menuText: 'Partes',
      title: 'Partes',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-content-copy',
      parent: null,
    },
    component: Partes,
  },
  {
    path: '/partes/:id',
    name: 'parte',
    meta: {
      componenteId: null,
      menuText: 'Partes',
      title: 'Partes',
      requiresAuth: true,
      icon: 'mdi-content-copy',
      parent: null,
    },
    component: Partes,
  },
  {
    path: '/clientes',
    name: 'clientes',
    meta: {
      componenteId: 14,
      menuText: 'Clientes',
      title: 'Clientes',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-account-group-outline',
      parent: null,
    },
    component: Clientes,
  },
  {
    path: '/clientes/:id',
    name: 'cliente',
    meta: {
      componenteId: null,
      menuText: 'Clientes',
      title: 'Clientes',
      requiresAuth: true,
      icon: 'mdi-account-group-outline',
      parent: null,
    },
    component: ClienteShow,
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    meta: {
      componenteId: 2,
      menuText: 'Usuarios y grupos',
      title: 'Administración de usuarios y grupos',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-account-cog-outline',
      parent: null,
    },
    component: Usuarios,
  },
  {
    path: '/acciones_masivas',
    name: 'acciones_masivas',
    meta: {
      componenteId: 6,
      menuText: 'Acciones masivas',
      title: 'Acciones Masivas',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-format-list-bulleted',
      parent: 'accionesMasivas',
    },
    component: AccionesMasivas,
  },
  {
    path: '/mis_grupos',
    name: 'mis_grupos',
    meta: {
      componenteId: 6,
      menuText: 'Mis grupos',
      title: 'Mis grupos',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-plus',
      parent: 'accionesMasivas',
    },
    component: MisGrupos,
  },
  {
    path: '/mis_comentarios',
    name: 'mis_comentarios',
    meta: {
      componenteId: 6,
      menuText: 'Mis comentarios',
      title: 'Mis comentarios',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-text-box-plus-outline',
      parent: 'accionesMasivas',
    },
    component: MisComentarios,
  },
  {
    path: '/arditimer',
    name: 'arditimer',
    meta: {
      componenteId: 3,
      menuText: 'Arditimer',
      title: 'Arditimer',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-timer-outline',
      parent: null,
    },
    component: Arditimer,
  },
  {
    path: '/ardiagenda',
    name: 'ardiagenda',
    meta: {
      componenteId: 4,
      menuText: 'Ardiagenda',
      title: 'Ardiagenda',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-account-box-multiple-outline',
      parent: null,
    },
    component: Ardiagenda,
  },
  {
    path: '/miPerfil',
    name: 'miPerfil',
    meta: {
      componenteId: null,
      menuText: 'MiPerfil',
      title: 'Mi Perfil',
      requiresAuth: true,
      icon: 'mdi-timer-outline',
      parent: null,
    },
    component: MiPerfil,
  },
  {
    path: '/saldos',
    name: 'saldos',
    meta: {
      componenteId: 7,
      menuText: 'Saldo de bolsas',
      title: 'Saldo de bolsas',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-briefcase-edit-outline',
      parent: 'packsMantenimientos',
    },
    component: Asientos,
  },
  {
    path: '/listadoAcciones',
    name: 'Listado Acciones',
    meta: {
      componenteId: 8,
      menuText: 'Listado de Acciones',
      title: 'Listado de Acciones',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-format-list-bulleted',
      // icon: 'mdi-clipboard-list-outline'
      /*
      mdi-format-list-bulleted
      mdi-format-list-checkbox
      mdi-format-list-numbered
      */
      parent: 'packsMantenimientos',
    },
    component: ListadoAcciones,
  },
  {
    path: '/packs',
    name: 'Bolsas de horas',
    meta: {
      componenteId: 9,
      menuText: 'Packs de horas',
      title: 'Packs de horas',
      requiresAuth: true,
      displayIn: 'appMenu',
      // icon: 'mdi-format-list-bulleted'
      icon: 'mdi-clipboard-list-outline',
      /*
      mdi-format-list-bulleted
      mdi-format-list-checkbox
      mdi-format-list-numbered
      */
      parent: 'packsMantenimientos',
    },
    component: PacksHoras,
  },
  {
    path: '/calendario',
    name: 'Calendario',
    meta: {
      componenteId: 5,
      menuText: 'Calendario',
      title: 'Calendario',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-calendar-month-outline',
      parent: null,
    },
    component: Calendario,
  },
  {
    path: '/registro-componentes',
    name: 'registroComponentes',
    meta: {
      componenteId: 10,
      menuText: 'Registro componentes',
      title: 'Registro componentes',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-package-variant',
      parent: null,
    },
    component: RegistroComponentes,
  },
  {
    path: '/informes',
    name: 'Informes',
    meta: {
      componenteId: 15,
      menuText: 'Informes',
      title: 'Informes',
      requiresAuth: true,
      displayIn: 'appMenu',
      icon: 'mdi-finance',
      AIpowered: true,
      beta: true,
      parent: null,
    },
    component: Informes,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '*',
    component: {
      template: '<div>404 Página no encontrada</div>',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  let authUser = store.state.login.authUser
  let isAuth = Boolean(Object.keys(store.state.login.authUser).length)
  // console.log(to.matched[0].path);
  if (to.matched[0].path === '*') {
    // La ruta no existe
    if (!isAuth) {
      redirect('login', to.fullPath)
    } else {
      next({
        name: 'dashboard',
      })
    }
  } else {
    // La ruta existe
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // Esta ruta requiere autenticación, verificamos si está logueado
      // si no, lo redirigimos a la página de login.
      if (!isAuth) {
        store.dispatch('setIntended', to)
        // next({
        //   name: 'login'
        // });
        redirect('login', to.fullPath)
      } else {
        // Verificamos si a la ruta que está intentando navegar el usuario tiene el acceso al componente. Si puede acceder, lo deja pasar
        // si no, lo devuelve al dashboard
        if (to.meta.componenteId !== null) {
          if (authUser.componentes.some(componente => componente.componente_id === to.meta.componenteId)) {
            next() // Este next deja pasar al usuario a la ruta que estaba solicitando
          } else {
            next({
              name: 'dashboard',
            })
          }
        } else {
          next() // Este next deja pasar al usuario a la ruta que estaba solicitando
        }
      }
    } else {
      //console.log(to.name+' === login && '+store.state.login.authUser);
      if (to.name === 'login' && isAuth) {
        next({
          name: 'dashboard',
        })
      } else {
        redirect('login', to.fullPath)
      }
    }
  }
})

export default router
